import BaseModel from './BaseModel';

class AnalyticsDashboardFilterOption extends BaseModel {}

AnalyticsDashboardFilterOption.collection =
  'projections.DashboardsFactsTable.FilterOptions';

export default AnalyticsDashboardFilterOption;
